<template>
  <div>
    <b-modal
      id="modal-status-perintah-kerja"
      size="lg"
      centered
      title="Rubah Status Surat Perintah Kerja"
      header-bg-variant="danger"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group label-cols-md="3">
          <template v-slot:label>
            Pilih Status <span class="text-danger">*</span>
          </template>
          <Multiselect
            v-model="dataEdit.status"
            :options="options"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            track-by="status"
            label="text"
            placeholder="-- Pilih Status --"
            @input="dataEdit.statusPoolKontrakAktif = dataEdit.status.status"
          ></Multiselect>
        </b-form-group>
      </b-form>

      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="$bvModal.hide('modal-status-perintah-kerja')"
        >
          {{ $store.state.form.batal }}
        </b-button>
        <b-button variant="primary" :disabled="busy" @click="upload">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["data", "detail"],
  data() {
    return {
      dataEdit: {
        status: "",
        statusPoolKontrakAktif: "",
        id: "",
      },
      busy: false,
      button: "Simpan",
      options: [
        { status: 0, text: "Aktif" },
        { status: 1, text: "Selesai /Habis Kontrak" },
        { status: 2, text: "Diberhentikan" },
        { status: 3, text: "Resign" },
        // { status: 4, text: "Diperpanjang" },
        // { status: 5, text: "Mutasi Jabatan" },
        { status: 6, text: "Meninggal" },
        { status: 7, text: "Hilang / Tanpa Keterangan" },
        { status: 9, text: "Pensiun" },
      ],
    };
  },
  methods: {
    async upload() {
      let vm = this;
      vm.button = "Mohon Tunggu";
      vm.busy = true;
      vm.dataEdit.id = vm.data.poolKontrakId
      vm.dataEdit.dataKaryawanId = vm.data.dataKaryawanId
      console.log(vm.dataEdit,'SP')
      let upload = await vm.$axios.post("poolKontrak/update",vm.dataEdit);
      if (upload.data.status == 200) {
        if (upload.data.message == "sukses") {
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alert", {
            variant: "success",
            msg: "BERHASIL UPLOAD SURAT PERJANJIAN KERJA",
            showing: true,
          });
          this.$bvModal.hide("modal-status-perintah-kerja");
        } else {
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alert", {
            variant: "danger",
            msg: upload.data.message,
            showing: true,
          });
          this.$bvModal.hide("modal-status-perintah-kerja");
        }
      } else {
        vm.button = "Simpan";
        vm.busy = false;
        vm.$emit("alert", {
          variant: "danger",
          msg: "TERJADI KESALAHAN PADA SERVER",
          showing: true,
        });
        this.$bvModal.hide("modal-status-perintah-kerja");
      }
    },
  },
  watch: {
    detail: function (newVal, oldVal) {
      let vm = this;
      if (oldVal != newVal) {
        for (let i = 0; i < vm.options.length; i++) {
          // console.log(vm.data.statusPoolKontrakAktif, vm.options[i].status);
          if (vm.data.statusPoolKontrakAktif == vm.options[i].status) {
            vm.dataEdit.status = vm.options[i];
          }
        }
      }
    },
  },
};
</script>